import { defineTokens } from "@pandacss/dev";
import { colors } from "./colors";
import { borderWidths } from "./border-widths";
import { spacing } from "./spacing";
import { radii } from "./radii";
import { fontWeights, fontSizes, fonts, lineHeights } from "./font";
import { motion } from "./motion";
import { shadows } from "./shadows";

/**
 * Design system tokens
 * All base design tokens for the Pinatagrams design system
 */
export const tokens = defineTokens({
	colors,
	borderWidths,
	radii,
	spacing,
	fonts,
	fontWeights,
	fontSizes,
	lineHeights,
	motion,
	shadows,
});
